"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSym = exports.applySym = exports.stateNameSym = exports.isInitializedSym = exports.isTransitioningSym = exports.emitterSym = exports.instanceSym = void 0;
exports.instanceSym = Symbol("instance");
exports.emitterSym = Symbol("emitter");
exports.isTransitioningSym = Symbol("isTransitioning");
exports.isInitializedSym = Symbol("isInitialized");
exports.stateNameSym = Symbol("stateName");
exports.applySym = Symbol("apply");
exports.clearSym = Symbol("clear");
//# sourceMappingURL=symbols.js.map